// src/api/endpoints.js
const normalizeApiRoot = (value) => {
  const raw = (value || "http://localhost:8000").trim().replace(/\/+$/, "");
  if (!raw) return "http://localhost:8000";
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  if (raw.startsWith("//")) return `https:${raw}`;
  return `https://${raw}`;
};

const API_ROOT = normalizeApiRoot(import.meta.env.VITE_API_ROOT);

export default {
  API_ROOT,

  // --- Authentication ---
  LOGIN: `${API_ROOT}/api/token/obtain/`,
  REFRESH: `${API_ROOT}/api/token/refresh/`,
  LOGOUT: `${API_ROOT}/api/blacklist/`,
  CURRENT_USER: `${API_ROOT}/api/current-user/`,
  PASSWORD_RESET: `${API_ROOT}/api/password_reset/`,
  PASSWORD_RESET_CONFIRM: `${API_ROOT}/api/password_reset/confirm/`,
  PASSWORD_CHANGE: `${API_ROOT}/api/password/change/`,
  VERIFY_EMAIL: `${API_ROOT}/api/verify-email/`,
  VERIFY_EMAIL_RESEND: `${API_ROOT}/api/verify-email/resend/`,
  USERS: `${API_ROOT}/api/users/`,
  ACCOUNT_DELETE: `${API_ROOT}/api/account/delete/`,
  REGION_CONSENT: `${API_ROOT}/api/region/consent/`,
  CONSENT_RECORD: `${API_ROOT}/api/consent/`,

  // --- Profiles ---
  PROFILE_ME: `${API_ROOT}/api/profiles/me/`,

  // --- Companies ---
  COMPANIES: `${API_ROOT}/api/companies/`,
  COMPANY_DETAIL: (slug) => `${API_ROOT}/api/companies/${slug}/`,
  COMPANY_FINANCIALS: (slug) => `${API_ROOT}/api/companies/${slug}/financials/`,
  COMPANY_MANAGE_DETAIL: (slug) => `${API_ROOT}/api/companies/${slug}/manage/`,
  COMPANY_MANAGE_OVERVIEW: (slug) => `${API_ROOT}/api/companies/${slug}/manage/overview/`,
  SCREENER_COMPANIES: `${API_ROOT}/api/screener/companies/`,
  SCREENER_VIEWS: `${API_ROOT}/api/screener/views/`,
  SCREENER_VIEW_DETAIL: (id) => `${API_ROOT}/api/screener/views/${id}/`,
  SCREENER_SCREENS: `${API_ROOT}/api/screener/screens/`,
  SCREENER_SCREEN_DETAIL: (id) => `${API_ROOT}/api/screener/screens/${id}/`,
  SCREENER_FILTER_OPTIONS: `${API_ROOT}/api/screener/filter-options/`,
  SCREENER_FINANCIAL_METRIC_DEFS: `${API_ROOT}/api/screener/financial-metric-definitions/`,
  RANKINGS: `${API_ROOT}/api/rankings/`,
  RANKING_DETAIL: (slug) => `${API_ROOT}/api/rankings/${slug}/`,
  LEARN_ARTICLES: `${API_ROOT}/api/learn/articles/`,
  LEARN_ARTICLE_DETAIL: (slug) => `${API_ROOT}/api/learn/articles/${slug}/`,
  SCORING_RUNS: `${API_ROOT}/api/scoring/runs/`,
  SCORING_TRANSPARENCY: `${API_ROOT}/api/scoring/transparency/`,
  SCORING_TRANSPARENCY_EXPORT: `${API_ROOT}/api/scoring/transparency/export/`,
  SCORING_TRANSPARENCY_DISTRIBUTION: `${API_ROOT}/api/scoring/transparency/distribution/`,

  // --- Claims & Updates ---
  COMPANY_CLAIMS: `${API_ROOT}/api/company-claims/`,
  COMPANY_CLAIM_DETAIL: (id) => `${API_ROOT}/api/company-claims/${id}/`,
  COMPANY_CLAIM_VERIFY: `${API_ROOT}/api/company-claims/verify/`,
  COMPANY_SUBMISSIONS: `${API_ROOT}/api/company-submissions/`,
  COMPANY_SUBMISSION_DETAIL: (id) => `${API_ROOT}/api/company-submissions/${id}/`,
  COMPANY_SUBMISSION_SUBMIT: `${API_ROOT}/api/company-submissions/submit/`,

  // --- Assets ---
  ASSETS: `${API_ROOT}/api/assets/`,
  ASSET_DETAIL: (id) => `${API_ROOT}/api/assets/${id}/`,
  RESOURCE_RESERVES: `${API_ROOT}/api/resource-reserves/`,
  RESOURCE_RESERVE_DETAIL: (id) => `${API_ROOT}/api/resource-reserves/${id}/`,
  RESOURCE_RESERVE_REPORT_SAVE: `${API_ROOT}/api/resource-reserve-reports/save/`,
  RESOURCE_RESERVE_REPORT_SAVE_DETAIL: (id) =>
    `${API_ROOT}/api/resource-reserve-reports/${id}/save/`,
  RESOURCE_RESERVE_ECONOMIC_SCENARIOS: `${API_ROOT}/api/resource-reserve-economic-scenarios/`,
  RESOURCE_RESERVE_ECONOMIC_SCENARIO_DETAIL: (id) =>
    `${API_ROOT}/api/resource-reserve-economic-scenarios/${id}/`,
  PRODUCTION_REPORT_SAVE: `${API_ROOT}/api/production-reports/save/`,
  PRODUCTION_REPORT_SAVE_DETAIL: (id) => `${API_ROOT}/api/production-reports/${id}/save/`,
  PRODUCTION_METRIC_DEFINITIONS: `${API_ROOT}/api/production-metric-definitions/`,
  COMMODITIES: `${API_ROOT}/api/commodities/`,
  PERIODS: `${API_ROOT}/api/periods/`,
  PERIOD_DETAIL: (id) => `${API_ROOT}/api/periods/${id}/`,

  // --- Favorites ---
  FAVORITES: `${API_ROOT}/api/favorites/`,
  FAVORITE_DETAIL: (id) => `${API_ROOT}/api/favorites/${id}/`,
  
  // --- Marketing --- 
  MARKETING_ACTIVE_BANNERS: (placement) => `${API_ROOT}/api/banners/${placement}/`,
  CONTACT_REQUEST: `${API_ROOT}/api/contact/`,

  // --- Jurisdictions ---
  JURISDICTIONS: `${API_ROOT}/api/jurisdictions/`,
  JURISDICTIONS_SIMPLE: `${API_ROOT}/api/jurisdictions/simple/`,
  JURISDICTION_DETAIL: (canonicalKey) => `${API_ROOT}/api/jurisdictions/${canonicalKey}/`,

};
